// Formatea Rut con puntos y guión
export function formatRut(value) {
  if (!value) {
    return ""; // O algún valor por defecto que quieras mostrar en caso de que "rut" sea inválido
  }
  let clean = value.replace(/[^0-9kK]/g, "").toUpperCase();
  clean = clean.slice(0, 9);

  let body = clean.slice(0, -1);
  let dv = clean.slice(-1);

  body = body.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  return dv ? `${body}-${dv}` : body;
}

// Formatea teléfono chileno (si lo es) y limpia el resto de caracteres
export function formatTelefono(telefono) {
  if (!telefono) return "";

  // Elimina espacios, guiones y paréntesis
  let clean = telefono.replace(/\D/g, "");

  // Si ya comienza con +, se asume formato internacional
  if (clean.startsWith("+") && !clean.startsWith("+56")) {
    return clean; // se deja igual
  }

  // Normaliza prefijos: si empieza con 56 sin el +, lo agrega
  if (clean.startsWith("56")) clean = "+" + clean;

  // Si es un móvil chileno (+56 9 XXXXXXXX)
  if (/^\+?569\d{8}$/.test(clean)) {
    const body = clean.slice(-8);
    return `+56 9 ${body.slice(0, 4)} ${body.slice(4)}`;
  }

  // Si es un fijo chileno (+56 2 XXXXXXXX)
  if (/^\+?562\d{8}$/.test(clean)) {
    const body = clean.slice(-8);
    return `+56 2 ${body.slice(0, 4)} ${body.slice(4)}`;
  }

  // Si no es chileno ni tiene formato reconocible, lo devuelve limpio
  return clean;
}

// Formatea nombre mientras se escribe: solo letras y espacios, capitaliza 
export function formatNombre(value) {
  if (!value) return "";

  // Elimina todo lo que no sea letra o espacio
  let clean = value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, "");

  // Evita espacios dobles
  clean = clean.replace(/\s{2,}/g, " ");

  // Capitaliza primera letra de cada palabra parcialmente
  clean = clean
    .split(" ")
    .map((word) => {
      if (!word) return "";
      // Capitaliza la primera letra y deja el resto tal cual
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");

  return clean;
}


